export enum UserActionTypes {
  GET_USERS = "@@USER/GET_USERS",
  GET_USERS_SUCCESS = "@@USER/GET_USERS_SUCCESS",
  GET_USERS_FAILURE = "@@USER/GET_USERS_FAILURE",

  CREATE_USER = "@@USER/CREATE_USER",
  CREATE_USER_SUCCESS = "@@USER/CREATE_USER_SUCCESS",
  CREATE_USER_FAILURE = "@@USER/CREATE_USER_FAILURE",

  UPDATE_USER = "@@USER/UPDATE_USER",
  UPDATE_USER_SUCCESS = "@@USER/UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILURE = "@@USER/UPDATE_USER_FAILURE",

  UPDATE_USER_STATUS = "@@USER/UPDATE_USER_STATUS",
  UPDATE_USER_STATUS_SUCCESS = "@@USER/UPDATE_USER_STATUS_SUCCESS",
  UPDATE_USER_STATUS_FAILURE = "@@USER/UPDATE_USER_STATUS_FAILURE",

  CREATE_USER_SESSION = "@@USER/CREATE_USER_SESSION",
  CREATE_USER_SESSION_SUCCESS = "@@USER/CREATE_USER_SESSION_SUCCESS",
  CREATE_USER_SESSION_FAILURE = "@@USER/CREATE_USER_SESSION_FAILURE",

  UPDATE_USER_SESSION = "@@USER/UPDATE_USER_SESSION",
  UPDATE_USER_SESSION_SUCCESS = "@@USER/UPDATE_USER_SESSION_SUCCESS",
  UPDATE_USER_SESSION_FAILURE = "@@USER/UPDATE_USER_SESSION_FAILURE",

  EXPORT_USER_SESSION = "@@USER/EXPORT_USER_SESSION",
  EXPORT_USER_SESSION_SUCCESS = "@@USER/EXPORT_USER_SESSION_SUCCESS",
  EXPORT_USER_SESSION_FAILURE = "@@USER/EXPORT_USER_SESSION_FAILURE",

  CLEAR_USERS = "@@USER/CLEAR_USERS",
  SET_FILTER = "@@USER/SET_FILTER",
}
